import { render, staticRenderFns } from "./UsersNew.vue?vue&type=template&id=6f21ccf4&scoped=true"
import script from "./UsersNew.vue?vue&type=script&lang=js"
export * from "./UsersNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21ccf4",
  null
  
)

export default component.exports